import React from 'react';
import {formatNumber} from 'helpers/utils'
import PropTypes from 'prop-types';

const AmountUSDRenderer = (props) => {
  const value = props.value ? '$' + formatNumber(props.value) : null

  return (
    <span>{value}</span>
  );
};

AmountUSDRenderer.propTypes = {
  value: PropTypes.number
};

export default AmountUSDRenderer;
